import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, Layout, Menu, Dropdown, Modal, Space, Avatar, Input } from 'antd';
import { DownOutlined, UserOutlined, SearchOutlined } from '@ant-design/icons';
import styles from './layout.module.less';
import {observer} from "mobx-react";
import { createFromIconfontCN } from '@ant-design/icons';
import logo from './logo.png';

import BackTop from 'components/BackTop/BackTop';
import Breadcrumb from 'components/Breadcrumb';
import { http,history, setReferrerUrl, addVisitLog } from 'libs';
// the hook
import { useTranslation } from 'react-i18next';
import gStore from 'store';
import goodsStore from 'pages/goods/store';
import cartStore from 'pages/cart/store';


export default observer(function (props) {
  const {t, i18n} = useTranslation();// {t('')}

  const searchParams = new URLSearchParams(window.location.search);
  // let params = searchParams.get('params')?.replaceAll(" ","+");
  const sign = searchParams.get('sign');
  const time = searchParams.get('time');
  const userEmail = searchParams.get('userEmail');
  const userName = searchParams.get('userName');
  const companyType = searchParams.get('companyType');
  const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }
  const prevPath = usePrevious(history.location.pathname)

  useEffect(() => {
    setReferrerUrl(prevPath)
  }, [history.location.pathname])

  useEffect(() => {
    if (!sign) {
      cartStore.fetchRecords()
    }
  }, [])

  const logout = () => {
    Modal.confirm({
      title: t('温馨提示'),
      content: t('确定要注销退出吗？'),
      okText: t('确认'),
      cancelText: t('取消'),
      onOk: () => {
        localStorage.setItem('token', '');
        localStorage.setItem('nickname', '');
        localStorage.setItem('redirect_uri', history.location.pathname + history.location.search + history.location.hash);
        history.push('/home');
        gStore.isLogin = true;
      }
    });
  }

  const activeClass = (path)=>{
    if(history.location.pathname.indexOf(path)!==-1){
      return 'currentMenu'
    }
  }

  let token = localStorage.getItem('token');
  let nickName = localStorage.getItem('nickname');
  const userMenu = (
    <Menu>
      {/* <Menu.Item>
        <a onClick={() => {
          history.push('/cart')
        }}>{t('我的购物车')}</a>
      </Menu.Item> */}
      <Menu.Item>
        <a onClick={() => {
          history.push('/user/purchase')
        }}>{t('我的求购单')}</a>
      </Menu.Item>
      <Menu.Item>
        <a onClick={() => {
          history.push('/user/order')
        }}>{t('我的订单')}</a>
      </Menu.Item>
      <Menu.Item>
        <a onClick={() => {
          history.push('/user/project')
        }}>{t('我的管理')}</a>
      </Menu.Item>
      {/* <Menu.Item>
        <a onClick={() => {
          history.push('/user/info')
        }}>{t('系统设置')}</a>
      </Menu.Item> */}
      <Menu.Divider/>
      <Menu.Item>
        <a onClick={logout}>{t('注销退出')}</a>
      </Menu.Item>
    </Menu>
  )

  const reloadGoods = () => {
    history.push('/goods');
  };

  // 搜索模块逻辑
  const [searchKeyword, setSearchKeyword] = useState('');

  const handleSearchInputChange = (e) => {
    setSearchKeyword(e.target.value);
  };

  const handleSearch = useCallback(() => {
    // if (!gStore.searchKeyword.trim()) return;
    const searchPath = `/goods`;
    
    // // 添加访问日志
    // addVisitLog({
    //   pageName: '产品搜索',
    //   fromPageUrl: history.location.pathname,
    //   pageUrl: `${window.location.origin}${searchPath}`,
    //   eventCode: 'ProductSearch',
    //   eventName: '产品搜索',
    //   content: JSON.stringify({ keyword: searchKeyword })
    // });
    
    history.push(searchPath);
    goodsStore.fetchRecords('search');
  }, [searchKeyword]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleClick = (name)=>{
    if (history.location.pathname !== name) {
      // if  (name === '/user/order') {
      //   addVisitLog({
      //     pageName: '我的订单',
      //     fromPageUrl: history.location.pathname,
      //     pageUrl:`${window.location.origin}${name}`,
      //     eventCode: 'MyOrder',
      //     eventName: "我的订单",
      //   })
      // }else{
      //   addVisitLog({
      //     pageName: '我的固资管理',
      //     fromPageUrl: history.location.pathname,
      //     pageUrl:`${window.location.origin}${name}`,
      //     eventCode: 'FixedAssetManagement',
      //     eventName: "我的固资管理",
      //   })
      // }
      history.push(name);
    }
  }

  const goCart = ()=>{
    addVisitLog({
      pageName: '我的购物车',
      fromPageUrl: history.location.pathname,
      pageUrl:`${window.location.origin}/cart`,
      eventCode: 'MyCart',
      eventName: "我的购物车",
    })
    history.push('/cart')
  }

  const changeMenu = (eventCode,eventName,path)=>{
    if (history.location.pathname !== path) { 
      addVisitLog({
        pageName: '查看服务介绍',
        fromPageUrl: window.referrerUrl,
        pageUrl:`${window.location.origin}${history.location.pathname}`,
        eventCode: eventCode,
        eventName: eventName,
      })
      history.push(path);
    }
  }


  return (
    <React.Fragment>
      <div hidden={history.location.pathname === '/login'||history.location.pathname === '/register'||history.location.pathname === '/forgetPassword'} className={styles.headerContainer}>
          <div className="dash-header">
            <div className="dash-main-content">
              {!token && (
                  <>
                    <div className="login">
                      <span>您好，</span>
                      <span className='hoverStyle' onClick={() => history.push('/login')}>请登录</span>
                    </div>
                  </>)
              }
              {token && (
                <>
                  <div className="name">{ nickName }</div>
                  <div className="divider">|</div>
                  <div className="order hoverStyle" onClick={() => handleClick('/user/purchase')}>个人中心</div>
                  <div className="divider">|</div>
                  <div className="name hoverStyle" style={{cursor: 'pointer'}} onClick={logout}>退出登录</div>
                </>
              )}
            </div>
          </div>
          <div className="search-module">
            <div className="search-main-content special-style">
              <div className="logo">
                <img src={logo} alt="logo" />
              </div>
              <div className="search">
                <Input value={gStore.searchKeyword} onChange={(e)=>{gStore.searchKeyword = e.target.value}} onKeyDown={handleKeyDown} style={{width: '240px'}}
                  placeholder="请输入产品名称/货号" allowClear />
                <div className="search-btn" onClick={()=>handleSearch()}>搜 索</div>
              </div>
              <div className="shoppingCart">
                <div className="cart" onClick={()=>goCart()}>
                  <i className="iconfont icon-gouwuche"/>
                  <span>我的购物车</span>
                </div>
                {gStore.shoppingTotal?
                  <div className="qp-badge">{ gStore.shoppingTotal }</div>:null
                 }
              </div>
            </div>
          </div>
        {/* <Layout.Header className={styles.header}> */}
        <div className="menu-wrapper">
        <div className="main-content special-style">
            <div className="all-category">
                <i className="iconfont icon-fenlei"></i>
                <span>全部商品分类</span>
            </div>
            <div className="menu-list">
                <div className={[activeClass('/home'),'list-det'].join(' ')} onClick={()=>changeMenu('HomeMenu','查看首页','/home')}>
                    <div className='currentMenuName'>首页</div>
                </div>
                <div className={[activeClass('/business'),'list-det'].join(' ')}
                    onClick={()=>changeMenu('ShowServiceIntroduce','查看服务介绍','/business')}>
                    <div className='currentMenuName'>服务介绍</div>
                </div>
                <div className={[activeClass('/fqa'),'list-det'].join(' ')}
                    onClick={()=>changeMenu('ShowFAQ','查看常见问题','/fqa')}>
                    <div className='currentMenuName'>常见问题</div>
                </div>
            </div>
            <div className="all-sort" v-show="isShowSortList"
              >
                {/* <div class="sort-layer">
                    <SortList></SortList>
                </div> */}
            </div>
        </div>
    </div>
          {/* <div className={styles.right}>
            <ul className={styles.navs}>
              <li className={[styles.nav,activeClass('/home')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/home')}>{t('首页')}</a></li>
              <li className={[styles.nav,activeClass('/business')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/business')}>{t('服务介绍')}</a></li>
              <li className={[styles.nav,activeClass('/goods')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => reloadGoods()}>{t('产品展示')}</a>
              </li>
              <li className={[styles.nav,activeClass('/fqa')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/fqa')}>{t('常见问题')}</a></li>
              <li hidden={!token} className={[styles.nav,activeClass('/user/order')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => handleClick('/user/order')}>{t('我的订单')}</a></li>
              <li hidden={!token} className={[styles.nav,activeClass('/user/customerFixedAssets')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => handleClick('/user/customerFixedAssets')}>{t('我的固资管理')}</a></li>
              <li hidden={!token} className={[styles.nav,activeClass('/cart')].join(' ')}><a className={[styles.link,'active_link'].join(' ')} onClick={() => history.push('/cart')}>{t('我的购物车')}</a></li>

              <li hidden={!token} className={styles.nav}>
                <Dropdown overlay={userMenu} placement="bottomCenter" arrow>
                  <a className={['ant-dropdown-link', styles.link].join(" ")} onClick={() => {
                    history.push('/user/purchase')
                  }}><Avatar style={{
                    backgroundColor: '#65B1AE',
                  }} icon={<UserOutlined />} /> {nickName} <DownOutlined/></a>
                </Dropdown>
              </li>

              <li hidden={!!token} className={styles.nav}>
                <span className={[styles.link,'active_link'].join(' ')} onClick={() => {
                  history.push('/home');
                  setTimeout(()=>{gStore.isLogin = true},[0])
                }}>{t('登录')}</span>
              </li>
            </ul>
          </div> */}
        {/* </Layout.Header> */}
      </div>

      <Breadcrumb showBrand={props.showBrand} crumb={props.crumb}/>

      <div hidden={props.hideToTop}>
        <BackTop/>
      </div>

    </React.Fragment>
  )
})

